Pixlee.module('SocialAuthApp.Show', function(Show, App, Backbone, Marionette, $) {
    Show.Controller = App.Controllers.Application.extend({
        initialize: function(options) {
            var _this = this;
            this.layout = this.getLayout();
            this.show(this.layout, {
                loading: true
            });
        },
        getLayout: function(options) {
            return new Show.Layout(options);
        }
    });

});